var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7412 6.74122C7.15057 6.33186 7.81428 6.33186 8.22365 6.74122L16.7769 15.2944C17.1862 15.7038 17.1862 16.3675 16.7769 16.7769V16.7769C16.3675 17.1863 15.7038 17.1863 15.2944 16.7769L6.7412 8.22367C6.33183 7.8143 6.33183 7.15059 6.7412 6.74122V6.74122Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7412 16.7773C7.15057 17.1867 7.81428 17.1867 8.22365 16.7773L16.7769 8.22412C17.1862 7.81475 17.1862 7.15103 16.7769 6.74167C16.3675 6.3323 15.7038 6.3323 15.2944 6.74167L6.7412 15.2949C6.33183 15.7043 6.33183 16.368 6.7412 16.7773Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5c80fd18ef728a84338e044bce4cf0da.svg";
export { ForwardRef as ReactComponent };